import { useAuthentication } from '@/composables/useAuthentication';
import { isValidChartRecid } from '@/composables/isValidChartRecid';
import { isJsonLayerResponse } from '@/interfaces/jsonLayerResponse';

export async function deleteChart(recid: string): Promise<void> {
  const { isLoggedIn, chartCode } = useAuthentication();

  if (!isLoggedIn.value) {
    throw new Error('Unable to delete chart - user is not logged in.');
  }

  const chartCodeCopy = chartCode.value;

  if (!isValidChartRecid(recid)) {
    throw new Error(`Unable to delete chart - recid argument is not a valid chart recid: ${typeof recid} ${recid}.`);
  }

  let jsonLayerResponse;

  try {
    const response = await fetch('/json/api', {
      method: 'POST',
      body: new URLSearchParams({
        cmd: 'delete-favorite',
        chartCode: chartCodeCopy,
        recid
      }),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      }
    });

    jsonLayerResponse = await response.json();

    window.sc3WorkbenchLogger.info(`Delete chart jsonLayerResponse for chartCode: ${chartCodeCopy} and recid: ${recid}`, jsonLayerResponse);
  } catch (e) {
    window.sc3WorkbenchLogger.error(`Failed to delete chart for chartCode: ${chartCodeCopy} and recid: ${recid}.`, e);

    throw new Error(`Failed to delete chart for chartCode: ${chartCodeCopy} and recid: ${recid}.`, { cause: e });
  }

  if (!isJsonLayerResponse(jsonLayerResponse)) {
    throw new Error(`Failed to delete chart for chartCode: ${chartCodeCopy} and recid: ${recid} - jsonLayerResponse does not match JsonLayerResponse interface.`);
  }

  if (!jsonLayerResponse.success) {
    throw new Error(`Failed to delete chart for chartCode: ${chartCodeCopy} and recid: ${recid} - jsonLayerResponse.success is false - jsonLayerResponse.message: ${jsonLayerResponse.message ?? '(message not provided)'}.`);
  }
}
